import { css } from '@emotion/react'

import { BP_SMALL_DOWN } from '../../../../lib/styles/breakpoints'
import { headerCss } from '../../../../lib/styles/typography'
import { srOnlyCss } from '../../../../lib/styles/cssStyles'

const h1Css = css`
  ${headerCss}
  margin-top: 1.25rem;
  margin-bottom: 0.75em;

  @media (${BP_SMALL_DOWN}) {
    margin-bottom: 1rem;
  }
`

type H1Props = {
  /** Children React Components  */
  children: React.ReactNode
  /** Optional class name */
  className?: string
  /** Optional id attribute */
  id?: string
  /** Render for screen-readers only */
  srOnly?: boolean
}

const H1 = ({ className, children, id, srOnly = false }: H1Props) => {
  const srCss = srOnly ? srOnlyCss : h1Css
  return (
    <h1 className={className} css={srCss} id={id}>
      {children}
    </h1>
  )
}

export default H1
